import { useState } from 'react';
import { toast } from '@cencosud-cencommerce/paris-uikit';

import { useRepository } from '@/Application/Providers/Repository';
import type { UpdateQuantityErrorDto } from '@/modules/cart/application/updateLineItemQuantity';
import { updateLineItemQuantity } from '@/modules/cart/application/updateLineItemQuantity';
import type { Cart } from '@/modules/cart/domain/Cart';
import { useShippingPageContext } from '@/Pages/ShippingPage/ShippingPageContext';
import type { MutatorHook } from '@/sections/shared/types/MutatorHook';

interface Entity {
  lineItemId: string;
  quantity: number;
}

const useUpdateLineItemQuantity = (): MutatorHook<Entity, Cart | undefined> => {
  const { cart: cartRepository } = useRepository();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { completeSkuHistory } = useShippingPageContext();

  const trigger = async ({ lineItemId, quantity }: Entity) => {
    setIsLoading(true);
    try {
      const res = await updateLineItemQuantity(
        cartRepository,
        lineItemId,
        quantity,
        completeSkuHistory
      );

      if (!res) {
        toast({
          status: 'error',
          body: 'Error al actualizar la cantidad'
        });
      }

      return res;
    } catch (e) {
      setError((e as Error)?.message ?? '');
      throw e as UpdateQuantityErrorDto;
    } finally {
      setIsLoading(false);
    }
  };

  return { trigger, isLoading, error };
};

export default useUpdateLineItemQuantity;
